import { BaseCoreGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/BaseCoreGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';

import { GameStore } from '../../../store/GameStore';

type canceledMsg = GameCommunicationMessageType & {
  mul: string;
};

export class GameComunicationGameCancledMulProcessor extends BaseCoreGameCommunicationProcessor {
  messageName = 'c_mul';
  delay = 0;

  process(message: canceledMsg, store: GameStore): void {
    const processDelay: number = 0;
    setTimeout(() => {
      this.handleBetsStats(message, store);
    }, processDelay);
  }

  private handleBetsStats(message: canceledMsg, store: GameStore): void {
    // update crash multiplier if multiplier is running.
  }
}
